// import VentanaContainer from './containers/ventana-container'
// export default VentanaContainer
import PantallaVentana from './pantalla-ventana';
export default PantallaVentana;